"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as he } from "./tv.config-BuYIgndg.mjs";
import * as e from "react";
import xe from "react";
import ye from "./ArrowSvg.js";
import { c as Ee } from "./createLucideIcon-BjO0sRuo.mjs";
import * as Ne from "react-dom";
import { u as Ce } from "./useTimeout-BRUciAq6.mjs";
import { u as Re } from "./useControlled-B2rPEZCb.mjs";
import { u as Z } from "./useEventCallback-CjuAhyNz.mjs";
import { u as be, a as oe } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { u as Ie } from "./useOpenInteractionType-CFukK4P5.mjs";
import { t as Oe, u as Se, a as Te, b as Me } from "./translateOpenChangeReason-C857LgAi.mjs";
import { P as we, m as De, u as j, C as je, e as _e, f as ke, E as Fe } from "./useRenderElement-B8V3_e8R.mjs";
import { u as Ae, a as He, I as Be, F as Le } from "./useScrollLock-COQT0_go.mjs";
import { b as Ve, d as Ue, F as Ke } from "./FloatingTree-vWe5pGqE.mjs";
import { u as Ye } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { u as Ge, s as ze } from "./safePolygon-9xumQ2iN.mjs";
import { u as Je } from "./useButton-CQeWQM5o.mjs";
import { a as qe, t as Qe, p as Y } from "./popupStateMapping-Cl0RMVD6.mjs";
import { F as We } from "./FloatingPortal-B6chGyBH.mjs";
import { i as Xe } from "./inertValue-CseOXFGF.mjs";
import { u as Ze } from "./useAnchorPositioning-DZydZPwe.mjs";
import { t as $e } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { u as te } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as se } from "./useBaseUiId-a-UPSsPQ.mjs";
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eo = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], oo = Ee("bell", eo), to = 300, G = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (G.displayName = "PopoverRootContext");
function b(s) {
  const o = e.useContext(G);
  if (o === void 0 && !s)
    throw new Error("Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>.");
  return o;
}
function $({
  props: s
}) {
  const {
    open: o,
    onOpenChange: l,
    defaultOpen: h = !1,
    delay: f = to,
    closeDelay: t = 0,
    openOnHover: r = !1,
    onOpenChangeComplete: n,
    modal: i = !1
  } = s, [p, c] = e.useState(), [P, x] = e.useState(), [E, y] = e.useState(), [N, O] = e.useState(null), [u, _] = e.useState(null), [d, m] = e.useState(null), [k, I] = e.useState(!0), S = e.useRef(null), F = Ce(), [g, L] = Re({
    controlled: o,
    default: h,
    name: "Popover",
    state: "open"
  }), {
    mounted: T,
    setMounted: C,
    transitionStatus: A
  } = be(g), {
    openMethod: v,
    triggerProps: H,
    reset: V
  } = Ie(g), M = Z(() => {
    C(!1), I(!0), m(null), n == null || n(!1), V();
  });
  oe({
    enabled: !s.actionsRef,
    open: g,
    ref: S,
    onComplete() {
      g || M();
    }
  }), e.useImperativeHandle(s.actionsRef, () => ({
    unmount: M
  }), [M]), e.useEffect(() => {
    g || F.clear();
  }, [F, g]);
  const U = Z((D, B, R) => {
    const ve = R === "trigger-hover", W = R === "trigger-press" && B.detail === 0, Pe = !D && (R === "escape-key" || R == null);
    function X() {
      l == null || l(D, B, R), L(D), D && m(R ?? null);
    }
    ve ? (I(!0), F.start(we, () => {
      I(!1);
    }), Ne.flushSync(X)) : X(), c(W || Pe ? W ? "click" : "dismiss" : void 0);
  }), w = Ye({
    elements: {
      reference: N,
      floating: u
    },
    open: g,
    onOpenChange(D, B, R) {
      U(D, B, Oe(R));
    }
  });
  Ae({
    enabled: g && i === !0 && d !== "trigger-hover" && v !== "touch",
    mounted: T,
    open: g,
    referenceElement: u
  });
  const ce = f, ue = Ge(w, {
    enabled: r && (v !== "touch" || d !== "trigger-press"),
    mouseOnly: !0,
    move: !1,
    handleClose: ze({
      blockPointerEvents: !0
    }),
    restMs: ce,
    delay: {
      close: t
    }
  }), de = Se(w, {
    stickIfOpen: k
  }), fe = Te(w, {
    outsidePressEvent: {
      mouse: "intentional",
      touch: "sloppy"
    }
  }), me = He(w), {
    getReferenceProps: q,
    getFloatingProps: Q
  } = Me([ue, de, fe, me]), ge = e.useMemo(() => ({
    open: g,
    setOpen: U,
    mounted: T,
    setMounted: C,
    transitionStatus: A,
    triggerElement: N,
    setTriggerElement: O,
    positionerElement: u,
    setPositionerElement: _,
    popupRef: S,
    titleId: P,
    setTitleId: x,
    descriptionId: E,
    setDescriptionId: y,
    triggerProps: De(q(), H),
    popupProps: Q(),
    floatingRootContext: w,
    instantType: p,
    openMethod: v,
    openReason: d,
    onOpenChangeComplete: n,
    openOnHover: r,
    delay: f,
    closeDelay: t,
    modal: i
  }), [g, U, T, C, A, u, P, E, q, N, H, Q, w, p, v, d, n, r, f, t, i]);
  return /* @__PURE__ */ a.jsx(G.Provider, {
    value: ge,
    children: s.children
  });
}
function so(s) {
  return b(!0) ? /* @__PURE__ */ a.jsx($, {
    props: s
  }) : /* @__PURE__ */ a.jsx(Ve, {
    children: /* @__PURE__ */ a.jsx($, {
      props: s
    })
  });
}
const K = /* @__PURE__ */ e.forwardRef(function(o, l) {
  const {
    render: h,
    className: f,
    disabled: t = !1,
    nativeButton: r = !0,
    ...n
  } = o, {
    open: i,
    setTriggerElement: p,
    triggerProps: c,
    openReason: P
  } = b(), x = e.useMemo(() => ({
    disabled: t,
    open: i
  }), [t, i]), {
    getButtonProps: E,
    buttonRef: y
  } = Je({
    disabled: t,
    native: r
  }), N = e.useMemo(() => ({
    open(u) {
      return u && P === "trigger-press" ? qe.open(u) : Qe.open(u);
    }
  }), [P]);
  return j("button", o, {
    state: x,
    ref: [y, p, l],
    props: [c, {
      [je]: ""
    }, n, E],
    customStyleHookMapping: N
  });
});
process.env.NODE_ENV !== "production" && (K.displayName = "PopoverTrigger");
const z = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (z.displayName = "PopoverPortalContext");
function no() {
  const s = e.useContext(z);
  if (s === void 0)
    throw new Error("Base UI: <Popover.Portal> is missing.");
  return s;
}
function ro(s) {
  const {
    children: o,
    keepMounted: l = !1,
    container: h
  } = s, {
    mounted: f
  } = b();
  return f || l ? /* @__PURE__ */ a.jsx(z.Provider, {
    value: l,
    children: /* @__PURE__ */ a.jsx(We, {
      root: h,
      children: o
    })
  }) : null;
}
const J = /* @__PURE__ */ e.createContext(void 0);
process.env.NODE_ENV !== "production" && (J.displayName = "PopoverPositionerContext");
function ne() {
  const s = e.useContext(J);
  if (!s)
    throw new Error("Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>.");
  return s;
}
const re = /* @__PURE__ */ e.forwardRef(function(o, l) {
  const {
    render: h,
    className: f,
    anchor: t,
    positionMethod: r = "absolute",
    side: n = "bottom",
    align: i = "center",
    sideOffset: p = 0,
    alignOffset: c = 0,
    collisionBoundary: P = "clipping-ancestors",
    collisionPadding: x = 5,
    arrowPadding: E = 5,
    sticky: y = !1,
    trackAnchor: N = !0,
    collisionAvoidance: O = _e,
    ...u
  } = o, {
    floatingRootContext: _,
    open: d,
    mounted: m,
    setPositionerElement: k,
    modal: I,
    openReason: S,
    openMethod: F,
    triggerElement: g
  } = b(), L = no(), T = Ue(), C = Ze({
    anchor: t,
    floatingRootContext: _,
    positionMethod: r,
    mounted: m,
    side: n,
    sideOffset: p,
    align: i,
    alignOffset: c,
    arrowPadding: E,
    collisionBoundary: P,
    collisionPadding: x,
    sticky: y,
    trackAnchor: N,
    keepMounted: L,
    nodeId: T,
    collisionAvoidance: O
  }), A = e.useMemo(() => {
    const M = {};
    return d || (M.pointerEvents = "none"), {
      role: "presentation",
      hidden: !m,
      style: {
        ...C.positionerStyles,
        ...M
      }
    };
  }, [d, m, C.positionerStyles]), v = e.useMemo(() => ({
    props: A,
    ...C
  }), [A, C]), H = e.useMemo(() => ({
    open: d,
    side: v.side,
    align: v.align,
    anchorHidden: v.anchorHidden
  }), [d, v.side, v.align, v.anchorHidden]), V = j("div", o, {
    state: H,
    props: [v.props, u],
    ref: [l, k],
    customStyleHookMapping: Y
  });
  return /* @__PURE__ */ a.jsxs(J.Provider, {
    value: v,
    children: [m && I === !0 && S !== "trigger-hover" && F !== "touch" && /* @__PURE__ */ a.jsx(Be, {
      inert: Xe(!d),
      cutout: g
    }), /* @__PURE__ */ a.jsx(Ke, {
      id: T,
      children: V
    })]
  });
});
process.env.NODE_ENV !== "production" && (re.displayName = "PopoverPositioner");
const io = {
  ...Y,
  ...$e
}, ie = /* @__PURE__ */ e.forwardRef(function(o, l) {
  const {
    className: h,
    render: f,
    initialFocus: t,
    finalFocus: r,
    ...n
  } = o, {
    open: i,
    instantType: p,
    transitionStatus: c,
    popupProps: P,
    titleId: x,
    descriptionId: E,
    popupRef: y,
    mounted: N,
    openReason: O,
    onOpenChangeComplete: u,
    modal: _,
    openMethod: d
  } = b(), m = ne();
  oe({
    open: i,
    ref: y,
    onComplete() {
      i && (u == null || u(!0));
    }
  });
  const k = e.useMemo(() => t == null ? d === "touch" ? y : 0 : typeof t == "function" ? t(d ?? "") : t, [t, d, y]), I = e.useMemo(() => ({
    open: i,
    side: m.side,
    align: m.align,
    instant: p,
    transitionStatus: c
  }), [i, m.side, m.align, p, c]), S = j("div", o, {
    state: I,
    ref: [l, y],
    props: [P, {
      "aria-labelledby": x,
      "aria-describedby": E
    }, c === "starting" ? ke : Fe, n],
    customStyleHookMapping: io
  });
  return /* @__PURE__ */ a.jsx(Le, {
    context: m.context,
    modal: _ === "trap-focus",
    disabled: !N || O === "trigger-hover",
    initialFocus: k,
    returnFocus: r,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (ie.displayName = "PopoverPopup");
const ae = /* @__PURE__ */ e.forwardRef(function(o, l) {
  const {
    className: h,
    render: f,
    ...t
  } = o, {
    open: r
  } = b(), {
    arrowRef: n,
    side: i,
    align: p,
    arrowUncentered: c,
    arrowStyles: P
  } = ne(), x = e.useMemo(() => ({
    open: r,
    side: i,
    align: p,
    uncentered: c
  }), [r, i, p, c]);
  return j("div", o, {
    state: x,
    ref: [l, n],
    props: [{
      style: P,
      "aria-hidden": !0
    }, t],
    customStyleHookMapping: Y
  });
});
process.env.NODE_ENV !== "production" && (ae.displayName = "PopoverArrow");
const le = /* @__PURE__ */ e.forwardRef(function(o, l) {
  const {
    render: h,
    className: f,
    ...t
  } = o, {
    setTitleId: r
  } = b(), n = se(t.id);
  return te(() => (r(n), () => {
    r(void 0);
  }), [r, n]), j("h2", o, {
    ref: l,
    props: [{
      id: n
    }, t]
  });
});
process.env.NODE_ENV !== "production" && (le.displayName = "PopoverTitle");
const pe = /* @__PURE__ */ e.forwardRef(function(o, l) {
  const {
    render: h,
    className: f,
    ...t
  } = o, {
    setDescriptionId: r
  } = b(), n = se(t.id);
  return te(() => (r(n), () => {
    r(void 0);
  }), [r, n]), j("p", o, {
    ref: l,
    props: [{
      id: n
    }, t]
  });
});
process.env.NODE_ENV !== "production" && (pe.displayName = "PopoverDescription");
const ao = he({
  slots: {
    trigger: [
      "flex size-10 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-gray-900 select-none hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-100 data-[popup-open]:bg-gray-100"
    ],
    popup: [
      "origin-[var(--transform-origin)] rounded-lg bg-[canvas] px-6 py-4 text-gray-900 shadow-lg  outline outline-1 outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0"
    ],
    arrow: [
      "data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-13px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180"
    ],
    title: ["text-base font-regular"],
    description: ["text-base text-gray-600"]
  },
  variants: {}
}), {
  trigger: ee,
  popup: lo,
  arrow: po,
  title: co,
  description: uo
} = ao(), Ao = (s) => {
  const {
    children: o,
    className: l,
    anchorEl: h,
    side: f = "bottom",
    align: t = "center",
    title: r,
    description: n,
    trigger: i,
    disabled: p,
    ...c
  } = s;
  return /* @__PURE__ */ a.jsxs(so, { ...c, children: [
    i ? /* @__PURE__ */ a.jsx(
      K,
      {
        disabled: p,
        className: ee(),
        render: ({ className: P, ...x }) => xe.cloneElement(i, x)
      }
    ) : /* @__PURE__ */ a.jsx(
      K,
      {
        disabled: p,
        className: ee(),
        children: /* @__PURE__ */ a.jsx(oo, { "aria-label": "Notifications" })
      }
    ),
    /* @__PURE__ */ a.jsx(ro, { children: /* @__PURE__ */ a.jsx(
      re,
      {
        sideOffset: 8,
        anchor: h,
        side: f,
        align: t,
        children: /* @__PURE__ */ a.jsxs(
          ie,
          {
            className: lo({ class: l }),
            children: [
              /* @__PURE__ */ a.jsx(ae, { className: po(), children: /* @__PURE__ */ a.jsx(ye, {}) }),
              r && /* @__PURE__ */ a.jsx(le, { className: co(), children: r }),
              n && /* @__PURE__ */ a.jsx(pe, { className: uo(), children: n }),
              o
            ]
          }
        )
      }
    ) })
  ] });
};
export {
  Ao as default
};
